import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import authStatus from 'constants/auth-status';
import { createActions } from './util';

export const actions = createActions({
  listen: 'Listen to Auth',
  login: 'Login',
  logout: 'Logout',
  open: 'Open Auth',
  invalidLogin: 'Invalid Login'
});

const baseSelector = state => state.auth;
export const selectors = {
  isLoggedIn: createSelector(
    baseSelector,
    ({ status }) => status === authStatus.LOGGED_IN
  )
};

export default createReducer(
  {
    [actions.open]: (_, payload) => ({
      status: authStatus.AWAITING_RESPONSE,
      isAuthorized: false
    }),
    [actions.login]: (_, payload) => ({
      status: authStatus.LOGGED_IN,
      invalidLogin: null,
      ...payload
    }),
    [actions.logout]: () => ({
      status: authStatus.ANONYMOUS,
      isAuthorized: false
    }),
    [actions.invalidLogin]: (state, _) => ({
      state,
      invalidLogin: 'Invalid login'
    })
  },
  { status: authStatus.ANONYMOUS, isAuthorized: false, invalidLogin: null }
);



// WEBPACK FOOTER //
// ./src/reducers/auth.js